import { isDefined } from "@clipboard-health/util-ts";

export const MIN_THRESHOLD_HOURS = 1;
export const MAX_THRESHOLD_HOURS = 168;

export const MIN_DIFFERENTIAL_PERCENT = 1;
export const MAX_DIFFERENTIAL_PERCENT = 40;

const differentialFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  signDisplay: "always",
  maximumFractionDigits: 0,
});

export function formatChargeDifferentialPercent(incrementalMultiplier: number): string {
  return differentialFormatter.format(incrementalMultiplier);
}

interface FormatLeadTimeRangeLabelParams {
  thresholdInHours: number;
  previousThresholdInHours?: number;
}

export function formatLeadTimeRangeLabel(params: FormatLeadTimeRangeLabelParams): string {
  const { thresholdInHours, previousThresholdInHours } = params;
  if (!isDefined(previousThresholdInHours)) {
    const unit = thresholdInHours === 1 ? "hour" : "hours";
    return `Posted within ${thresholdInHours} ${unit} of shift start`;
  }
  return `Posted between ${previousThresholdInHours} and ${thresholdInHours} hours of shift start`;
}
